import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';

const News = () => {
  const blogs = [
    {
      tag: 'Clean Energy',
      title: 'Hydrogen Fuel Cell Technology: The Future of Clean Energy in Transportation',
      excerpt: 'Explore how hydrogen fuel cells are revolutionizing the automotive industry, offering zero-emission alternatives for heavy-duty and long-haul transportation.',
      img: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?q=80&w=2070&auto=format&fit=crop'
    },
    {
      tag: 'Artificial Intelligence',
      title: 'How AI and Machine Learning are Driving the Evolution of Intelligent Vehicles',
      excerpt: 'Discuss the role of artificial intelligence and machine learning in enabling smarter, safer, and fully autonomous driving systems of tomorrow.',
      img: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?q=80&w=2070&auto=format&fit=crop'
    }
  ];

  return (
    <section id="news" className="py-24 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-cyan/10 border border-cyan/20 text-cyan text-sm font-heading mb-4">
              Insights & Updates
            </div>
            <h2 className="text-3xl sm:text-4xl font-heading font-bold text-white">
              Latest From Our <span className="text-cyan">Technology Blog</span>
            </h2>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {blogs.map((blog, index) => (
            <motion.article 
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="bg-charcoal rounded-2xl overflow-hidden border border-cyan/10 group hover:border-cyan/30 transition-all duration-300"
            >
              <div className="h-64 overflow-hidden relative">
                <div className="absolute inset-0 bg-navy/40 group-hover:bg-transparent transition-all z-10"></div>
                <img src={blog.img} alt={blog.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute top-4 left-4 z-20">
                  <span className="bg-navy/80 backdrop-blur-md border border-cyan/30 text-cyan text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider">
                    {blog.tag}
                  </span>
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-xl font-heading font-bold text-white mb-4 group-hover:text-cyan transition-colors line-clamp-2">
                  {blog.title}
                </h3>
                <p className="text-slate-400 mb-6 line-clamp-3">
                  {blog.excerpt}
                </p>
                <button className="flex items-center gap-2 text-cyan font-semibold hover:text-white transition-colors">
                  Read More <FiArrowRight className="transform group-hover:translate-x-2 transition-transform" />
                </button>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default News;